import { superstyled } from '@zenbusiness/zui/styles';

import { MethodIcon } from '../TwoStepVerification/TwoStepVerification.style';

// A listed passkey is always enrolled, so its icon background never changes.
export const PasskeyIcon = superstyled({
  tag: MethodIcon,
  name: 'Passkeys',
  slot: 'PasskeyIcon',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.blue.light,
  }),
});
